import {homeIndexUrls, homeIndex} from './homeindex'
import {homeDetailUrls, homeDetail} from './homedetail'

export const homeUrls = [
  ...homeIndexUrls,
  ...homeDetailUrls
]

export const home = {
  homeIndex,
  homeDetail
}



// WEBPACK FOOTER //
// ./src/api/gip/home/index.js